import {CrudService} from '../services/';

export const sendEmail = (data) => {

    return CrudService._post({
        url: `emails/send`,
        data
    });
};
